import axios from 'axios';
import getUrl from 'utils/getUrl';
import { generateTakerRejection } from './utils/takerApiUtils';
import { mapResponseToApiModel } from './dataMapper/responseDataMapper';

export default (responseUuid, body) =>
  axios
    .patch(getUrl.api(`response/${responseUuid}`), mapResponseToApiModel(body))
    .catch(generateTakerRejection());
